import { List } from 'immutable';
import { isImmutableList } from '../../types/typeGuards/immutableJs';
import { CommunicationSubscriptionDisplayType } from '../DisplayTypes';
import { makeOperator } from './Operator';
export default makeOperator({
  name: 'CommunicationSubscriptionOptOut',
  values: [{
    name: 'value',
    defaultValue: List(),
    isValid: value => isImmutableList(value) && !value.isEmpty()
  }, {
    name: 'isInexclusive',
    defaultValue: true
  }],
  displayType: CommunicationSubscriptionDisplayType
});